/* Presentation only: native Horizon remains responsible for variants, prices and ordering. */
if (!customElements.get('hp-product-summary')) {
  customElements.define('hp-product-summary', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      document.addEventListener('variant:update', event => {
        const data = event.detail?.data;
        if (String(data?.productId) !== this.dataset.productId || !data?.html) return;
        const selector = `hp-product-summary[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`;
        const updated = data.html.querySelector(selector);
        if (!updated) return;
        this.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
        if (updated.dataset.size) this.dataset.size = updated.dataset.size;
        else delete this.dataset.size;
        this.highlightTable();
      }, { signal: this.abortController.signal });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.highlightTable(), { once: true, signal: this.abortController.signal });
      } else {
        this.highlightTable();
      }
    }

    disconnectedCallback() { this.abortController?.abort(); }

    highlightTable() {
      const size = this.dataset.size;
      if (!size) return;
      document.querySelectorAll('.hp-refined-full-description .hp-product-table tbody tr').forEach(row => {
        const selected = row.cells[0]?.textContent.trim() === size;
        row.classList.toggle('hp-refined-selected-row', selected);
      });
    }
  });
}
